@let projects = projects$ | async;
<div class="p-4" style="width: 600px">
  <form
    tbs-form
    tbsLayout="vertical"
    [formGroup]="form"
    (ngSubmit)="onSubmit()"
  >
    <tbs-form-item>
      <tbs-form-label [tbsRequired]="true">Project Name</tbs-form-label>
      <tbs-form-control>
        <tbs-select
          tbsPlaceHolder="Select Project"
          formControlName="project"
          [tbsLoading]="projects === null"
        >
          @for ( project of projects; track project._id) {
          <tbs-option
            [tbsValue]="project"
            [tbsLabel]="project.project.project_name"
          ></tbs-option>
          }
        </tbs-select>
      </tbs-form-control>
    </tbs-form-item>
    <div class="row">
      <div class="col-6">
        <tbs-form-item>
          <tbs-form-label [tbsRequired]="true">Mission Date</tbs-form-label>
          <tbs-form-control>
            <tbs-date-picker
              tbsPlaceholder="Select start date"
              formControlName="date"
              [tbsAllowClear]="false"
              [tbsFormat]="'MMM dd, yyyy'"
            ></tbs-date-picker>
          </tbs-form-control>
        </tbs-form-item>
      </div>
      <div class="col-6">
        <tbs-form-item>
          <tbs-form-label [tbsRequired]="true">Mission Completion Time</tbs-form-label>
          <tbs-form-control>
            <tbs-select
              formControlName="time"
            >
              @for ( option of timeOptions; track option) {
              <tbs-option
                [tbsValue]="option"
                [tbsLabel]="option"
              ></tbs-option>
              }
            </tbs-select>
          </tbs-form-control>
        </tbs-form-item>
      </div>
    </div>

    <button
      type="submit"
      tbs-button
      tbsType="solid"
      [style.width.%]="100"
      [disabled]="form.invalid"
      [tbsLoading]="loading"
    >
      Next
    </button>
  </form>
</div>
